import { TrackingFeature } from '../types/feature';

export const CAFeature: TrackingFeature = {
  enabledFacebookCapiV2: true,
  enabledTrackProductPageViewMoreThan3: false,
};
